import { getCurrentPath } from "@faire/web/common/Path";
import React from "react";
import { Redirect } from "react-router-dom";

import * as RetailerPaths from "@faire/retailer/paths";

export const SignInAndRedirect = () => {
  return (
    <Redirect
      to={RetailerPaths.home({
        signIn: "1",
        email: getCurrentPath().searchParams.get("email") ?? undefined,
        redirectTo: getCurrentPath().toString(),
      })}
    />
  );
};
